/**
 * Account Management API service
 * Handles account settings and management
 */

import api from './api';
import type {
  AccountDetails,
  UpdateAccountData,
  DisableAccountData,
  UpdateAccountResponse,
  DisableAccountResponse,
  TransferOwnershipData,
  TransferOwnershipResponse,
} from '../types/account';

export const accountService = {
  /**
   * Get current account details
   */
  async getAccount(): Promise<AccountDetails> {
    const response = await api.get<{ account: AccountDetails }>('/api/account');
    return response.data.account;
  },

  /**
   * Update account settings
   * @param data Account name to update
   */
  async updateAccount(data: UpdateAccountData): Promise<UpdateAccountResponse> {
    const response = await api.put<UpdateAccountResponse>('/api/account', data);
    return response.data;
  },

  /**
   * Disable account (requires password confirmation)
   * @param data Password for confirmation
   */
  async disableAccount(data: DisableAccountData): Promise<DisableAccountResponse> {
    const response = await api.delete<DisableAccountResponse>('/api/account', { data });
    return response.data;
  },

  /**
   * Transfer account ownership to another team member
   * @param data New owner ID and password for confirmation
   */
  async transferOwnership(data: TransferOwnershipData): Promise<TransferOwnershipResponse> {
    const response = await api.post<TransferOwnershipResponse>('/api/account/transfer-ownership', data);
    return response.data;
  },
};

export default accountService;
